// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1zEF6","upload":"Small_upload__3RdH6","imageWrap":"Small_imageWrap__3WUwA","removeBtn":"Small_removeBtn__1Xu7N"};